const PROVIDER_NAMES: Record<string, string> = {
  fourvps: '4VPS',
  bitlaunch: 'BitLaunch',
  hetzner: 'Hetzner',
  upcloud: 'UpCloud',
  dynadot: 'Dynadot',
};

export function providerName(provider: string | null | undefined): string {
  if (!provider) return '—';
  return PROVIDER_NAMES[provider.toLowerCase()] ?? provider;
}
